import React, { Component } from "react";
import PropTypes from "prop-types";
import RollHeader from "~/scripts/components/RollHeader";
import IndexRoll from "~/scripts/components/IndexRoll";
import RollFooter from "~/scripts/components/RollFooter";
import FadeUp from "~/scripts/components/transitions/FadeUp";

const friends = [
    {
        id: "64",
        title: "Reset",
        uri: "http://www.resetcontent.com/",
        logo: require("~/images/friends/reset.svg")
    },
    {
        id: "63",
        title: "Smuggler",
        uri: "https://smugglersite.com/",
        logo: require("~/images/friends/smuggler.svg")
    }
];

class Home extends Component {
    static propTypes = {
        onMount: PropTypes.func,
        setPrevLocation: PropTypes.func,
        state: PropTypes.string,
        headingPos: PropTypes.object,
        toggleSpecialPageTransition: PropTypes.func,
        posY: PropTypes.number
    };

    state = {
        loading: false,
        content: {}
    };

    async componentDidMount() {
        const { onMount } = this.props;

        if (onMount) {
            onMount();
        }

        this.setState({ loading: true });

        const response = await fetch("/api/home");
        const data = await response.json();

        const heroVideosData = data.heroVideos;
        const randomVideoIndex =
            heroVideosData && heroVideosData.length
                ? Math.floor(Math.random() * heroVideosData.length)
                : 0;
        const randomVideoSelection = data.randomVideoSelection;

        const heroVideo =
            heroVideosData &&
            (randomVideoSelection
                ? heroVideosData[randomVideoIndex]
                : heroVideosData[0]);

        let directors = data.directorsList;

        if (data.randomDirectorOrder) {
            directors = directors.sort(() => Math.random() - 0.5);
        }

        this.setState({
            loading: false,
            content: {
                heroVideo,
                socialMediaAccounts: data.socialMediaAccounts,
                directors: directors
            }
        });
    }

    render() {
        const {
            posY,
            setPrevLocation,
            state,
            headingPos,
            toggleSpecialPageTransition
        } = this.props;
        const { loading, content } = this.state;
        const { socialMediaAccounts, heroVideo, directors } = content;

        return (
            <div className="page-wrapper">
                <div className="home">
                    {heroVideo && (
                        <RollHeader
                            posY={posY}
                            showReelUrl={heroVideo.showReelUrl}
                            line1={heroVideo.line1}
                            line2={heroVideo.line2}
                            poster={heroVideo.poster}
                        />
                    )}
                    <FadeUp pose={loading ? "exit" : "enter"}>
                        <IndexRoll
                            state={state}
                            headingPos={headingPos}
                            directors={directors}
                            posY={posY}
                            setPrevLocation={setPrevLocation}
                            toggleSpecialPageTransition={
                                toggleSpecialPageTransition
                            }
                        />
                        <RollFooter
                            friends={friends}
                            {...socialMediaAccounts}
                        />
                    </FadeUp>
                </div>
            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/scripts/components/pages/Home.js